module.exports = __webpack_public_path__ + "static/media/4.fa57aef1.jpg";